import { Injectable } from '@angular/core';
import { EntityListResolver } from 'src/app/core/services/entity-list.resolver';
import { LiftService } from './lift.service';
import { LiftList } from '../models/lift-list.model';
import { LiftCriteria } from '../models/lift.criteria';

@Injectable({
  providedIn: 'root'
})
export class LiftListResolver extends EntityListResolver<LiftService, LiftList, LiftCriteria> {
  constructor(
    liftService: LiftService
  ) {
    super(liftService, new LiftCriteria());
  }
}
